import Web3 from 'web3';
import {bytes32ToNote} from './chords/NoteConstants.js';
import {noteToBytes32} from './chords/NoteConstants.js';
import {asciiToNote} from './chords/NoteConstants.js';
import {web3} from './web3.js';

const bs58 = require('bs58');
const metamaskInstalled = typeof window.web3 !== 'undefined';
const nullBytes32 = web3.utils.padLeft('0x0', 64);

class EthereumDataType {
    constructor(toConversion, fromConversion) {
        this.toConversion = toConversion;
        this.fromConversion = fromConversion;
    }

    convertTo(jsValue) {
        return this.toConversion(jsValue);
    }

    convertFrom(ethereumValue) {
        if (ethereumValue === nullBytes32) {
            return null;
        }
        return this.fromConversion(ethereumValue);
    }
}

function ipfsHashToBytes32(ipfs_hash) {
    var h = bs58.decode(ipfs_hash).toString('hex').replace(/^1220/, '');
    if (h.length != 64) {
        return null;
    }
    return '0x' + h;
}

function bytes32ToIPFSHash(hash_hex) {
    var buf = new Buffer(hash_hex.replace(/^0x/, '1220'), 'hex')
    return bs58.encode(buf)
}

function trimEmpty(str) {
    let trimmed = "";
    for (let i in str) {
        if (str.charCodeAt(i) == 0) {
            continue;
        }
        trimmed += str.charAt(i);
    }
    return trimmed;
}

export const IPFS_HASH = new EthereumDataType(
    (x) => ipfsHashToBytes32(x),
    (x) => bytes32ToIPFSHash(x));

export const INT_8 = new EthereumDataType(
    (x) => web3.utils.padLeft(web3.utils.numberToHex(x), 64),
    (x) => web3.utils.hexToNumber(x));

export const INT_16 = new EthereumDataType(
    (x) => web3.utils.padLeft(web3.utils.numberToHex(x), 64),
    (x) => trimEmpty(web3.utils.toAscii(x)));

export const INT_32 = new EthereumDataType(
    (x) => web3.utils.padLeft(web3.utils.numberToHex(x), 64),
    (x) => web3.utils.hexToNumber(x));

export const UINT_256 = new EthereumDataType(
    (x) => web3.utils.padLeft(web3.utils.numberToHex(parseInt(x)), 64),
    (x) => web3.utils.hexToNumber(x));

export const BYTES_32 = new EthereumDataType(
    (x) => web3.utils.padRight(web3.utils.fromAscii(x), 64),
    (x) => trimEmpty(web3.utils.toAscii(x)));

export const BYTES_32_LEFT = new EthereumDataType(
    (x) => web3.utils.padLeft(web3.utils.fromAscii(x), 64),
    (x) => trimEmpty(web3.utils.toAscii(x)));


export const BYTES_32_ENCRYPTED = new EthereumDataType(
    (x) => web3.utils.padLeft(web3.utils.toHex(x), 64),
    (x) => stripLeadingZeroes(x.slice(2)));

function stripLeadingZeroes(str) {
    for (let i=0; i < str.length; i++) {
        if (str.slice(i, i+1) !== '0') {
            return str.slice(i);
        }
    }
 
    return str;
}




export const RIGHT_PADDED_BYTES_32 = new EthereumDataType(
    (x) => web3.utils.padRight(web3.utils.toHex(x), 64),
    (x) => trimEmpty(web3.utils.toAscii(x)));

export const NOTES_BYTES_32 = new EthereumDataType(
    (x) => web3.utils.padRight(x, 64),
    (x) => trimEmpty(web3.utils.toAscii(x)).split('').map(x => asciiToNote[x]));

export const NOTE_BYTES_32 = new EthereumDataType(
    (x) => web3.utils.padRight(x, 64),
    (x) => asciiToNote[trimEmpty(web3.utils.toAscii(x))]);

export const ADDRESS = new EthereumDataType(
    (x) => web3.utils.padLeft(x, 64),
    (x) => getAddress(x));

export const STRING = new EthereumDataType(
    (x) => web3.utils.padLeft(x[0], 64),
    (x) => trimEmpty(web3.utils.toAscii(x)));

export const BYTES_32_ARRAY = (len) =>
    new EthereumDataType(
        (x) => x, // no need to convert to
        (data) => data.slice(2, 2 + len * 64));

function getAddress(x) {
    return '0x' + x.slice(x.length - 40);
}


